var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'note-bubble-hover':
      _vm.hoverCheck['history-list-' + _vm.historyItem.type + '-' + _vm.historyItem.id]
  },on:{"mouseover":function($event){return _vm.$set(
      _vm.hoverCheck,
      'history-list-' + _vm.historyItem.type + '-' + _vm.historyItem.id,
      true
    )},"mouseleave":function($event){return _vm.$set(
      _vm.hoverCheck,
      'history-list-' + _vm.historyItem.type + '-' + _vm.historyItem.id,
      false
    )},"click":function($event){return _vm.showActionEntry({ type: 'note', record: _vm.historyItem })}}},[_c('div',{staticClass:"note-bubble"},[_c('div',{staticClass:"msg-bubble-content"},[_c('div',{staticClass:"no-whitespace"},[_vm._v(_vm._s(_vm.historyItem.note))])])]),_c('div',{staticClass:"msg-detail-header ml-auto"},[_c('span',[_c('i',{staticClass:"ui-icon write",class:{
          'ui-icon-hide': !_vm.hoverCheck[
            'history-list-' + _vm.historyItem.type + '-' + _vm.historyItem.id
          ]
        }})]),_c('span',{staticClass:"msg-detail-name"},[_vm._v(_vm._s(_vm.userNameFromHistoryItem(_vm.historyItem)))]),_c('span',{staticClass:"msg-detail-time"},[_vm._v(_vm._s(_vm.formattedDateTime(_vm.historyItem.updatedAt)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }